import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { seoHead } from "@/lib/seo/head";
import AdminGate from "@/components/AdminGate";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/admin/sms")({
  head: () => seoHead("/admin/sms"),
  component: () => (
    <AdminGate><AdminSms /></AdminGate>
  ),
});

function AdminSms() {
  const { data: msgs } = useQuery({
    queryKey: ["admin-sms"],
    queryFn: async () =>
      (await supabase.from("sms_messages").select("*").order("created_at", { ascending: false }).limit(200)).data ?? [],
  });
  const { data: optOuts } = useQuery({
    queryKey: ["admin-sms-optouts"],
    queryFn: async () => (await supabase.from("sms_opt_outs").select("*").order("opted_out_at", { ascending: false })).data ?? [],
  });
  return (
    <div className="container mx-auto max-w-5xl px-4 py-10 space-y-8">
      <h1 className="text-2xl font-bold text-foreground">Text messages</h1>
      <section>
        <h2 className="font-semibold mb-2 text-foreground">Recent texts and replies</h2>
        {!msgs?.length ? (
          <p className="text-sm text-muted-foreground">No texts yet. Texting starts once Twilio is connected.</p>
        ) : (
          <table className="w-full text-sm">
            <thead><tr className="text-left text-muted-foreground"><th>When</th><th>Direction</th><th>Kind</th><th>Phone</th><th>Message</th><th>Status</th></tr></thead>
            <tbody>
              {msgs.map((m) => (
                <tr key={m.id} className="border-t border-border align-top">
                  <td className="py-1 pr-2 whitespace-nowrap">{new Date(m.created_at).toLocaleString()}</td>
                  <td className="pr-2">{m.direction}</td>
                  <td className="pr-2">{m.kind}</td>
                  <td className="pr-2">{m.phone}</td>
                  <td className="pr-2">{m.body}</td>
                  <td>{m.status}{m.error ? ` (${m.error.slice(0, 60)})` : ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>
      <section>
        <h2 className="font-semibold mb-2 text-foreground">Opted out ({optOuts?.length ?? 0})</h2>
        <ul className="text-sm text-muted-foreground">
          {optOuts?.map((o) => <li key={o.phone}>{o.phone} · {new Date(o.opted_out_at).toLocaleDateString()}</li>)}
        </ul>
      </section>
    </div>
  );
}
